import I18n from '@/rI18n';
import { memo, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import DisplayOptionBySetting from './DisplayOptionBySetting';
import { getOptionDisplayLength } from './handler/ChatBoxHandler';


function ListCategoriesOption({ message, onClickHandler, chatbotSettings,isModePreview, isMaximizedPanel, getMessage }) {
    const [messageState, setMessagesState] = useState(message)
    useEffect(() => {
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    
    const [maxNumberAnswer, setMaxNumberAnswer] = useState(0);
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);

    useEffect(() => {
        if (!isModePreview) {
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }
        }
    }, [previewSetting]);

    let isShowSeeMore = maxNumberAnswer < messageState?.content?.length;

    return (
        <div className={isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'}>
            <div className="text-question">{getMessage('bot_initial_message')}</div>
            {messageState?.content?.slice(0, maxNumberAnswer)?.map(option => (
                <div key={`${option.id}-qa`}>
                        <DisplayOptionBySetting 
                            label={option.name}
                            optionDisplayLength={getOptionDisplayLength(chatbotSettings, previewSetting)}
                            onClickHandler={ () => onClickHandler(option, messageState.idMessage)}
                            isMaximizedPanel={isMaximizedPanel}
                        />
                </div>
            ))}
            {isShowSeeMore && (<div className='option-seemore'>{getMessage('bot_other_options_hint')}</div>)}
        </div>
    );
}

export default memo(ListCategoriesOption);
